import { Icon20CopyOutline, Icon20InfoCircleOutline, Icon20MoreVertical, Icon20RectangleInfoOutline } from '@vkontakte/icons';
import { Link, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ReactElement, useEffect, useRef, useState } from 'react';

import styles from './LegalBlock.css';

export interface LegalBlockProps {
    erid: string;
    isMobile?: boolean;
}

export const LegalBlock: React.FC<LegalBlockProps> = ({ erid, isMobile }) => {
    const [isOpen, setIsOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement>(null);

    const config: Array<{ icon: ReactElement; text: string | ReactElement }> = [
        {
            icon: <Icon20InfoCircleOutline />,
            text: (
                <Link href="https://blog.mail.ru/mail_space_leto/" target="_blank" rel="noopener noreferrer">
                    Условия акции
                </Link>
            ),
        },
        {
            icon: <Icon20RectangleInfoOutline />,
            text: 'ООО «ВК» ИНН 7743001840',
        },
        {
            icon: <Icon20CopyOutline />,
            text: `ERID: ${erid}`,
        },
    ];

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handleClickOutside = (event: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    return (
        <div ref={rootRef} className={classNames(styles.root, { [styles.mobile_root]: isMobile })}>
            <div className={styles.iconWrapper}>
                <Icon20MoreVertical onClick={() => setIsOpen(!isOpen)} />
            </div>
            {isOpen && (
                <div className={styles.popup}>
                    <Text className={styles.title}>Реклама 0+</Text>
                    <div className={styles.list}>
                        {config.map((item, index) => (
                            <div key={index} className={styles.item}>
                                {item.icon}
                                {item.text}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
